{{each audio}}
<li>
    <span class="aplayer-list-cur" style="background-color: {{ $value.theme || theme }};"></span>
    <span class="aplayer-list-index">{{ $index + index }}</span>
    <span class="aplayer-list-title">{{ $value.name }}</span>
    <span class="aplayer-list-author">{{ $value.artist }}</span>
</li>
{{/each}}